export default {
  'title:goldkid': 'Балаға арналған Kaspi Gold',
  'title:error': 'Қате'
}
